/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeDRadiusUpRightIcon20Solid = forwardRef('ArrowShapeDRadiusUpRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 2.957c0-1.114 1.346-1.672 2.134-.884l6.69 6.69a1.75 1.75 0 0 1 0 2.474l-6.69 6.69c-.788.787-2.134.23-2.134-.884V14c-1.32.006-2.358.054-3.394.395-1.14.375-2.342 1.132-3.866 2.746-.574.609-1.692.293-1.728-.64-.14-3.695.917-6.355 2.738-8.085C5.437 6.816 7.69 6.097 10 6.01V2.957Z" })));
});
